import { brandInfo } from "../../../constant";
import "./style.scss";
import { useChatBot } from "./hooks";
import { useElement, useLocale } from "../../../hooks";
import { useCallback } from "react";

export const ChatBot = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const Input = useElement("Input");
  const Link = useElement("Link");
  const { inputQuery, chatbotToggle, chatData, askQuery, activeQuery } =
    useChatBot();

  const renderChat = useCallback(() => {
    return chatData.map((item, index) => {
      return (
        <div className="chat-container" key={index}>
          <div className={"msg " + item.msgType}>
            <span>{item.msg}</span>
          </div>
        </div>
      );
    });
  }, [chatData]);

  return (
    <>
      <div className="chatboy">
        <Link
          target="blank"
          className="whats-app"
          href={`https://api.whatsapp.com/send?phone=91${brandInfo.phone}&amp;text=Hello%20${brandInfo.name.capital}!`}
          rel="noreferrer"
        >
          <i className="hi-whatsapp"></i>
        </Link>
      </div>
      <div className="chatbot" id="chatbot">
        <div className="chat-header" onClick={chatbotToggle}>
          <i className="hi-chat msg-icon"></i>
          <div className="title">{t("chatbotName")}</div>
          <div className="close">
            <i className="hi-close"></i>
          </div>
        </div>
        <div className="chatbot-wrapper">{renderChat()}</div>
        <form className="msg-input" onSubmit={askQuery}>
          <Input
            placeholder={t("placeholder.chatMsg")}
            required
            name="activeQuery"
            value={activeQuery}
            onChange={inputQuery}
          />
          <Button className="send-msg" type="submit">
            <i className="hi-send"></i>
          </Button>
        </form>
      </div>
    </>
  );
};
